// ===== DEFENCE & ARMED FORCES =====
const DEFENCE = [
  {
    id: "nda",
    name: "National Defence Academy (NDA) - Army, Navy, Air Force",
    stream: "science",
    category: "defence",
    summary:
      "Tri-service academy for training future officers of Army, Navy, and Air Force. Prestigious career path for 10+2 students.",
    eligibility:
      "10+2 with PCM for Air Force & Navy; any stream for Army. Must qualify UPSC NDA exam + SSB interview + medicals.",
    exams: ["NDA & NA (UPSC)"],
    colleges: ["National Defence Academy (Pune)", "IMA Dehradun", "INA Ezhimala", "Air Force Academy Dundigal"],
    source: "UPSC NDA Official Notification & Armed Forces websites.",
    keywords: ["army", "navy", "air force", "officer", "ssb", "nda"],
  },
  {
    id: "tes-army",
    name: "Technical Entry Scheme (TES) - Indian Army",
    stream: "science",
    category: "defence",
    summary: "Direct commission as Lieutenant in Indian Army for PCM students via TES route.",
    eligibility:
      "10+2 with PCM (minimum 60% aggregate); shortlisted candidates called for SSB Interview + medicals.",
    exams: ["TES (Army) - Direct Entry"],
    colleges: ["Indian Military Academy (IMA), Dehradun"],
    source: "Join Indian Army official portal.",
    keywords: ["technical entry", "army", "ssb"],
  },
  {
    id: "navy-btech",
    name: "Indian Navy B.Tech Cadet Entry Scheme",
    stream: "science",
    category: "defence",
    summary: "Four-year B.Tech program at Indian Naval Academy leading to commission as Sub Lieutenant.",
    eligibility:
      "10+2 with PCM (70%) + minimum 50% in English; JEE Main rank mandatory.",
    exams: ["JEE Main"],
    colleges: ["Indian Naval Academy (INA), Ezhimala"],
    source: "Indian Navy official website.",
    keywords: ["navy", "btech", "officer"],
  },
  {
    id: "afcat",
    name: "Air Force Common Admission Test (AFCAT)",
    stream: "all",
    category: "defence",
    summary: "Entry to Indian Air Force as Flying Officer, Technical or Ground Duty branch.",
    eligibility: "Open for all Streams, 10+2 + Graduation (but you can plan early after 12th).",
    exams: ["AFCAT"],
    colleges: ["Air Force Academy, Dundigal"],
    source: "AFCAT official website.",
    keywords: ["air force", "flying officer", "afcat"],
  },
  {
    id: "airforce-x-y",
    name: "Indian Air Force Airmen (Group X & Y)",
    stream: "science",
    category: "defence",
    summary:
      "Join Indian Air Force as Airmen in Technical (X) & Non-Technical (Y) trades after 10+2.",
    eligibility:
      "10+2 with PCM (50%) for Group X; any stream with English (50%) for Group Y. Must clear online exam + physical + medical.",
    exams: ["IAF X & Y Group Exam"],
    colleges: ["IAF Training Centers"],
    source: "Indian Air Force official website.",
    keywords: ["air force", "x group", "y group", "airmen"],
  },
  {
    id: "merchant-navy",
    name: "Merchant Navy - Deck & Engine Cadet",
    stream: "science",
    category: "defence",
    summary:
      "Career in commercial shipping as Deck Officer or Marine Engineer after 10+2 PCM.",
    eligibility:
      "10+2 with PCM (minimum 60%); must clear IMU-CET + medical & eyesight standards.",
    exams: ["IMU-CET"],
    colleges: ["MERI Kolkata", "Tolani Maritime Institute", "International Maritime Institute"],
    source: "Indian Maritime University & DG Shipping approved colleges.",
    keywords: ["merchant navy", "marine", "shipping", "deck", "engine"],
  },
  {
    id: "coast-guard",
    name: "Indian Coast Guard - Navik & Yantrik",
    stream: "science",
    category: "defence",
    summary:
      "Join Indian Coast Guard as Navik (General Duty) or Yantrik (Technical) after 10+2.",
    eligibility:
      "10+2 with PCM (50%) for Navik GD; Diploma in Engineering for Yantrik.",
    exams: ["Coast Guard GD/Yantrik Exam"],
    colleges: ["Indian Coast Guard Training Centers"],
    source: "Indian Coast Guard official website.",
    keywords: ["coast guard", "navik", "yantrik"],
  },
  {
    id: "assam-rifles",
    name: "Assam Rifles & Paramilitary Forces",
    stream: "all",
    category: "defence",
    summary:
      "Join as Rifleman/Constable in Assam Rifles, BSF, CISF, CRPF, ITBP & SSB after 10+2.",
    eligibility: "Generally Open for all Streams, 10+2 pass; must qualify physical tests, written exam & medicals.",
    exams: ["CAPF Constable/Rifleman Exam"],
    colleges: ["Central Armed Police Training Centers"],
    source: "MHA Recruitment Notifications.",
    keywords: ["paramilitary", "assam rifles", "crpf", "bsf", "cisf"],
  },
  {
    id: "police-si",
    name: "State Police Constable / Sub-Inspector (12th Entry)",
    stream: "all",
    category: "defence",
    summary:
      "Join State Police services as Constable or prepare for Sub-Inspector exams after 12th.",
    eligibility: "Generally Open for all Streams, 10+2 pass; must clear state police written exam + PET + medical.",
    exams: ["State Police Constable Exam"],
    colleges: ["State Police Academies"],
    source: "State Police Recruitment Boards.",
    keywords: ["police", "constable", "sub inspector"],
  },
];

export default DEFENCE;
